import React from 'react'
import { Outlet } from 'react-router-dom'

function PluginLayout() {
    return (
        <><Outlet /></>
    )
}

export default PluginLayout